import React from "react";

export default class Th extends React.Component {
  render() {
    return <th>{this.props.children}</th>;
  }
}
